import { Record, Union } from "../fable_modules/fable-library-js.4.25.0/Types.js";
import { record_type, union_type, list_type, class_type } from "../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { PracticeViewModel_$reflection } from "../ThreeDocs.Models/View/PracticeViewModel.js";
import { Notification_$reflection, ErrorMessage_$reflection } from "../ThreeDocs.Models/Api/Api.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.25.0/Result.js";
import { CustomShared_$reflection, PracticesUpdateArgs_$reflection, PracticesCrudOutbound_$reflection } from "./PracticesCrudConfig.js";
import { Types_Model$4_$reflection, Types_Msg$4_$reflection } from "../ThreeDocs.Client.StateMachine.Crud/CrudComponent.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExceptionError", "Authenticated", "GetPractices", "GetPracticesResult", "Notification", "PracticeCrudMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Client.Practices.Types.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(PracticeViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(PracticeViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", Notification_$reflection()]], [["Item", Types_Msg$4_$reflection(PracticeViewModel_$reflection(), PracticesCrudOutbound_$reflection(), PracticesUpdateArgs_$reflection(), CustomShared_$reflection())]]]);
}

export class Model extends Record {
    constructor(PracticeCrudModel) {
        super();
        this.PracticeCrudModel = PracticeCrudModel;
    }
}

export function Model_$reflection() {
    return record_type("Client.Practices.Types.Model", [], Model, () => [["PracticeCrudModel", Types_Model$4_$reflection(PracticeViewModel_$reflection(), PracticesCrudOutbound_$reflection(), PracticesUpdateArgs_$reflection(), CustomShared_$reflection())]]);
}

